import { redirect } from '@tanstack/react-router';
type RedirectLocation = {
  pathname: string;
  searchStr: string;
};
const ID_MANAGEMENTS_TO_IDS_REGEX = /^\/id-managements/;
export function redirectIdManagementsToIds(location: RedirectLocation): never {
  const newPathname = location.pathname.replace(ID_MANAGEMENTS_TO_IDS_REGEX, '/ids');
  const to = location.searchStr ? `${newPathname}${location.searchStr}` : newPathname;
  throw redirect({
    to
  });
}